<template>
    <div :class="$style.popup">
        <PopupTopNav @close="closePopup" :title="title" />

        <div v-show="!computedPlaces" :class="$style.loader">
            <div class="is-loading"></div>
        </div>

        <place-map
            v-if="computedPlaces"
            :places="computedPlaces"
            :center="center"
            :active-place-id="placeId"
            :smart-pan="true"
        >
            <template #left-column="{ activePlace, navigation }">
                <PlaceColumn
                    v-if="activePlace"
                    :id="activePlace.uuid || activePlace.id"
                    :name="activePlace.name"
                    :address="activePlace.address"
                    :href="activePlace.permalink"
                    :body="activePlace.bodyText"
                    :images="activePlace.images"
                    :website="activePlace.contact?.website?.value"
                    :instagram-url="activePlace.contact?.instagram?.value"
                    :buttons="activePlace.contact?.buttons || []"
                ></PlaceColumn>
                <PlaceListPaging
                    :place-page="computedPlaces"
                    :current-index="computedPlaces.indexOf(activePlace)"
                    @next="navigation.goToNextPlace"
                    @prev="navigation.goToPrevPlace"
                />
            </template>
        </place-map>
    </div>
</template>

<script setup>
import PlaceMap from '../place-map/PlaceMap.vue'
import PlaceColumn from '../place-map/PlaceColumn.vue'
import PlaceListPaging from '../place-list/components/PlaceListPaging.vue'
import http from '../../Shared/util/http.js'
import { computed, ref } from 'vue'
import PopupTopNav from './PopupTopNav.vue'
import mapMarkers from '../../../es6/src/modules/map/markers.js'

const emit = defineEmits(['close'])
const props = defineProps({
    title: String,
    center: [Array],
    placeId: {
        type: String,
        required: false,
        default: null,
    },
    places: {
        type: Array,
        required: false,
        default: () => [],
    },
})

const place = ref(null)
const similarPlaces = ref(null)

if (props.placeId) {
    http.get(`/api/map/place/${props.placeId}/`).then((response) => {
        place.value = response.data.data

        place.value.markerOptions = {
            label: null,
        }
    })

    http.get(`/api/map/place/${props.placeId}/similar/`).then((response) => {
        similarPlaces.value = response.data.data
    })
}

const computedPlaces = computed(() => {
    if (props.places.length > 0) {
        return props.places
    }

    if (!place.value || !similarPlaces.value) return null

    return [
        place.value,
        ...similarPlaces.value.map((place) => {
            place.markerOptions = {
                icon: mapMarkers.DOT,
                label: null,
            }

            return place
        }),
    ]
})

const closePopup = () => {
    emit('close')
}
</script>

<style module>
.popup {
    width: 100%;
    height: 100%;
    display: grid;
    transition: grid-template-columns 0.3s ease-in-out;
    grid-template-areas:
        'nav'
        'map';
    grid-template-columns: 1fr;
    grid-template-rows: 54px 1fr;
}

@media (min-width: 992px) {
    .popup {
        grid-template-areas:
            'nav nav'
            'aside map';
        grid-template-columns: 530px 1fr;
        grid-template-rows: 54px auto;
    }
}

.loader {
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 1 / span 2;
}
</style>
